import { AggregateElementViewModel } from './aggregate-element-view-model';
import { ClassConstructor } from '@nts/std/serialization';
import { ClassInformationType } from '@nts/std/types';
import type { AggregateMetaDataInterface, ClassInformationInterface, CollectionViewModelInterface, CoreOrchestratorViewModelInterface, ItemViewModelInterface } from '@nts/std/interfaces';
import type { IdentityInterface, ModelInterface } from '@nts/std/interfaces';

export class ItemViewModel<
    TModel extends ModelInterface<TIdentity>,
    TIdentity extends IdentityInterface>
    extends AggregateElementViewModel<TModel, TIdentity> implements ItemViewModelInterface<TIdentity, TModel>, ClassInformationInterface {

    classType = ClassInformationType.ItemViewModel;

    async initItemViewModel(
        domainModel: TModel,
        metadata: AggregateMetaDataInterface,
        orchestratorViewModel: CoreOrchestratorViewModelInterface,
        ownerCollection?: CollectionViewModelInterface<TIdentity, TModel, this>,
        isNewItem?: boolean,
        path: string = '',
        isMock: boolean = false,
        domainModelType: ClassConstructor<TModel> = null
    ) {
        this.reservedPath = path;
        this.reservedName = '';
        this.isMock = isMock;

        await this.initAggregateElementViewModel({
            domainModel,
            aggregateMetaData: metadata,
            orchestratorViewModel,
            isMock,
            domainModelType
        });
    }
}
